<template>
  <div class="new-subscription-page">
    <PageHeader></PageHeader>
    <div class="new-subscription-info">
      <el-descriptions title="" :column="4" border>
          <el-descriptions-item label="订阅名称">{{ subscriptioninfo.name }}</el-descriptions-item>
          <el-descriptions-item label="品牌名称">{{ brandname }}</el-descriptions-item>
          <el-descriptions-item label="套餐等级">{{ subscriptioninfo.packageName }}</el-descriptions-item>
          <el-descriptions-item label="起始时间">{{ subscriptioninfo.init }} - {{ subscriptioninfo.expire }}</el-descriptions-item>
          <el-descriptions-item label="客户账号">{{ subscriptioninfo.email }}</el-descriptions-item>
          <el-descriptions-item label="代理账号">{{ agencyemail }}</el-descriptions-item>
          <el-descriptions-item label="主负责人">{{ csmemail }}</el-descriptions-item>
          <el-descriptions-item label="副负责人">{{ depcsmemail }}</el-descriptions-item>
          <el-descriptions-item label="监测渠道" :span="2">{{ subscriptioninfo.channelname }}</el-descriptions-item>
          <el-descriptions-item label="监测频次" :span="2">{{ subscriptioninfo.monitortype }}</el-descriptions-item>
          <el-descriptions-item label="定制报告" :span="4" v-if="subscriptioninfo.url != ''">{{ subscriptioninfo.url }}</el-descriptions-item>
      </el-descriptions>
      <div class="importinfo-row">
        <el-button type="primary" @click="showimport = true" size="mini">导入SKU</el-button>
        <!-- <el-button type="warning" @click="getBrandKeywords" size="mini">设置关键词</el-button> -->
        <el-tooltip class="item" effect="dark" content="导入SKU需要使用标准模板，如果您是第一次导入，请先下载模板。" placement="top">
          <el-button type="text" @click="downloadImportTemplate" size="mini">下载模板</el-button>
        </el-tooltip>
      </div>
    </div>

    <el-dialog
      custom-class="skuimport-data"
      title="导入SKU"
      :visible.sync="showimport"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="700px">
      <div class="sku-import-body">
        <div class="sku-import-btn" v-if="false === skuimported">
          <input ref="excel-upload-input" class="upload-input-file" type="file" accept=".xlsx, .xls" @change="handleClick" />
        </div>
        <div class="sku-import-lists" v-if="true === skuimported">
          <el-table :data="exceldata" size="mini">
            <el-table-column show-overflow-tooltip label="用户SKUCode" prop="用户SKUCode/UserSKUCode"></el-table-column>
            <el-table-column show-overflow-tooltip label="商品名" prop="商品名称/Product Name"></el-table-column>
            <el-table-column show-overflow-tooltip label="别名" prop="别称/简称/代号Alias/nickname/short-name"></el-table-column>
            <el-table-column show-overflow-tooltip label="商品简介" prop="商品描述/Product description"></el-table-column>
            <el-table-column show-overflow-tooltip label="系列" prop="系列/product line/series"></el-table-column>
            <el-table-column show-overflow-tooltip label="型号" prop="型号/model"></el-table-column>
            <el-table-column show-overflow-tooltip label="参数" prop="规格参数（容量、支数、大小)/Specification"></el-table-column>
            <el-table-column show-overflow-tooltip label="常规监测价" prop="常规监测价(日常到手价）低于此价格为破价"></el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="cancelImport">取消</el-button>
        <el-button :disabled="exceldata.length == 0" type="primary" size="mini" @click="uploadExcel">确定</el-button>
      </span>
    </el-dialog>
    
    <el-dialog
      title="关键词设置"
      custom-class="editdialog getbrandkeywordsdialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :visible.sync="showeditbrandkeywords"
      width="700px">
      <div class="edit-form">
        <p>根据您上传的SKU信息，我们为您自动提取到以下关键词。</p>
        <p>您可以进行修改或重新提取关键词。</p>
        <p>如无修改，请点击提交。</p>
        <el-form :model="addbrandform" ref="addbrandform" label-width="0" size="small">
          <el-form-item label="" prop="keywords">
            <el-col :span="24">
              <el-input type="textarea" :rows="4" v-model="brandkeywords"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="">
            <el-col :span="24">
              <el-button type="warning" @click="getBrandKeywords()" size="small">重新提取</el-button>
              <el-button type="primary" @click="confirmAddBrand()" size="small">提交</el-button>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import * as XLSX from 'xlsx/xlsx.mjs'
import PageHeader from '@/components/NewSubscription/PageHeader'
export default {
  components: {
    PageHeader,
  },
  data(){
    return{
      subscriptioninfo: {},
      showimport: false,
      exceldata: [],
      skuimported: false,
      taskid: '',
      agencyemail: '',
      csmemail: '',
      depcsmemail: '',
      brandname: '',
      brandnameen: '',
      skuinfo: [],
      addbrandform: {},
      brandkeywords: '',
      showeditbrandkeywords: false
    }
  },
  mounted(){
    let that = this
    this.getBaseInfo(function(){
      that.getUser()
      that.getBrand()
    })
  },
  methods: {

    /**
     * monitortype
     */
    initMonitortype: function(id){
      let src = ''
      id = id * 1
      switch (id) {
        case 1:
          src = "8次/天";
          break;
        case 2:
          src = '3次/天';
          break;
        case 5:
          src = '2次/天';
          break;
        case 3:
          src = "1次/天";
          break;
        case 4:
          src = '1次/周';
          break;
        case '':
          src = '停止监测';
          break;
      }
      return src
    },

    /**
     * 获取用户列表
     */
    getUser: function(email){
      let that = this
      let url = that.API_URL + '/sys/users/list'
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: {search: email},
        success: function(data) {
          let origin_user = JSON.parse(JSON.stringify(data.results))
          let duser = origin_user.find(item => item.userId == that.subscriptioninfo.duserid)
          let csmuser = origin_user.find(item => item.userId == that.subscriptioninfo.CSM)
          let depcsmuser = origin_user.find(item => item.userId == that.subscriptioninfo.DepCSM)
          that.agencyemail = duser != undefined ? duser.email : ''
          that.csmemail = csmuser != undefined ? csmuser.email : ''
          that.depcsmemail = depcsmuser != undefined ? depcsmuser.email : ''
        },
        error: function(response) {
          console.log('getUser', response)
        }
      })
    },

    /**
     * 获取品牌列表
     */
    getBrand: function(brand){
      let that = this
      let url = that.API_URL + '/sys/brand/list'
      $.ajax({
        url: url, type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true, crossDomain: true,
        data: {search: brand},
        success: function(data) {
          let origin_brand = JSON.parse(JSON.stringify(data.results))
          let brand = origin_brand.find(item => item.brandId == that.subscriptioninfo.brandId)
          that.brandname = brand.name
          that.brandnameen = brand.brand
        },
        error: function(response) {
          console.log('getBrand', response)
        }
      })
    },
    
    /**
     * 获取订阅基本信息
     */
    getBaseInfo: function(callback){
      let that = this
      let url = that.API_URL + '/sys/subscription/list?search=&page=1&size=25&taskId=' + this.$route.params.taskid
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(data) {
          let _baseinfo = data.results[1][0]
          _baseinfo.init = that.$moment(data.results[1][0].init).format('YYYY-MM-DD')
          _baseinfo.expire = that.$moment(data.results[1][0].expire).format('YYYY-MM-DD')
          _baseinfo.monitortype = that.initMonitortype(data.results[1][0].monitortype)
          that.subscriptioninfo = _baseinfo
          callback()
        },
        error: function(response) {
          console.log('getBaseInfo', response)
        }
      })
    },
    
    /**
     * 下载模板
     */
    downloadImportTemplate: function(){
      let _now = new Date()
      let filename = 'SKUBASEINFO'
      let a = document.createElement('a')
      a.download = filename + '_' + this.$moment(_now).format('YYYYMMDDHHmmss') + '.xlsx'
      a.href = 'https://bps.simplybrand.com/static/SKUBASEINFO.xlsx'
      $("body").append(a)
      a.click()
      $(a).remove()
    },
    
    /**
     * 是否Excel
     */
    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name)
    },

    /**
     * 点击按钮选取Excel文件
     */
    handleClick(e) {
      const files = e.target.files
      const rawFile = files[0]
      if (!rawFile) return
      if (!this.isExcel(rawFile)) {
        this.$message.error('Only supports upload .xlsx, .xls, .csv suffix files')
        return
      }
      this.upload(rawFile)
    },
    
    /**
     * 上传
     */
    upload(rawFile) { 
      this.sheetname = []
      this.tableData = []
      this.$refs['excel-upload-input'].value = null
      this.readerData(rawFile)
    },

    /**
     * 读取Excel
     */
    readerData(rawFile) {
      return new Promise((resolve) => {
        let reader = new FileReader()
        reader.onload = e => {
          let data = e.target.result
          let workbook = XLSX.read(data, { type: 'array' })
          let _sheetname = workbook.SheetNames[0]
          let _worksheet = workbook.Sheets[_sheetname]
          let _results = XLSX.utils.sheet_to_json(_worksheet)
          this.exceldata = _results
          resolve()
        }
        reader.readAsArrayBuffer(rawFile)
        this.skuimported = true
      })
    },

    /**
     * 取消上传
     */
    cancelImport: function(){
      this.exceldata = []
      this.skuimported = false
      this.showimport = false
    },

    /**
     * 确定上传
     */
    uploadExcel: function(){
      let that = this
      let url = that.API_URL + '/sys/databaseinfo/importskuBaseInfo'
      let _lists = this.exceldata
      let _query = []
      for(let i=0; i<_lists.length; i++){
        let _obj = {
          TaskID: that.$route.params.taskid,
          SKUDesc: _lists[i]['商品描述/Product description'] == undefined ? '' : _lists[i]['商品描述/Product description'],
          SKUName: _lists[i]['商品名称/Product Name'] == undefined ? '' : _lists[i]['商品名称/Product Name'],
          SKUSeries: _lists[i]['系列/product line/series'] == undefined ? '' : _lists[i]['系列/product line/series'],
          SKUModel: _lists[i]['型号/model'] == undefined ? '' : _lists[i]['型号/model'],
          SKUShortName: _lists[i]['别称/简称/代号Alias/nickname/short-name'] == undefined ? '' : _lists[i]['别称/简称/代号Alias/nickname/short-name'],
          SKUSpec: _lists[i]['规格参数（容量、支数、大小)/Specification'] == undefined ? '' : _lists[i]['规格参数（容量、支数、大小)/Specification'],
          UserSKUCode: _lists[i]['用户SKUCode/UserSKUCode'] == undefined ? '' : _lists[i]['用户SKUCode/UserSKUCode'],
          price: _lists[i]['常规监测价(日常到手价）低于此价格为破价'] == undefined ? '' : _lists[i]['常规监测价(日常到手价）低于此价格为破价'],
        }
        _query.push(_obj)
      }
      let skulist = []
      for(let i=0; i<_query.length; i++){
        let _item = {
          brand: that.brandname,
          SKUName: _query[i].SKUName,
          SKUSeries: _query[i].SKUSeries,
          SKUModel: _query[i].SKUModel,
          SKUSpec: _query[i].SKUSpec
        }
        skulist.push(_item)
      }
      that.skuinfo = skulist
      // that.cancelImport()
      // that.getBrandKeywords()
      $.ajax({
        url: url,
        type: "POST",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        contentType: "application/json",
        data: JSON.stringify(_query),
        success: function(data) {
          console.log(data)
          // that.$message({
          //   type: 'success',
          //   message: '批量导入成功'
          // })
          that.cancelImport()
          that.getBrandKeywords()
          // console.log(that.skuinfo)
        },
        error: function(response) {
          console.log(response)
        }
      })
    },
    
    /**
     * 获取关键词
     */
    getBrandKeywords: function(){
      let that = this
      let _query = that.skuinfo
      const kewWordsloading = this.$loading({
        lock: true,
        text: '关键词提取中，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        customClass: 'getkeywordsloading'
      });
      $.ajax({
        url: '//similarpic.simplybrand.com/api/keywordAI/getCompletions',
        type: "POST",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        contentType: "application/json",
        data: JSON.stringify(_query),
        success: function(res) {
          that.showeditbrandkeywords = true
          that.brandkeywords = res.join(',')
          kewWordsloading.close()
        },
        error: function(response) {
          console.log(response)
        }
      })
    },

    /**
     * 添加关键词
     */
    confirmAddBrand: function(){
      let that = this
      let url = that.API_URL + '/sys/brand/edit'
      let query = {
        brandid: that.subscriptioninfo.brandId,
        name: that.brandname,
        brand: that.brandnameen,
        logo: '',
        keywords: that.brandkeywords,
        trademark: ''
      }
      $.ajax({
        url: url,
        type: "PUT",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          console.log('confirmAddBrand', data)
          that.$router.push({name: 'ProductInfoList',params: {subid: that.subscriptioninfo.subid, poid: that.subscriptioninfo.poid}})
        },
        error: function(response) {
          console.log('confirmAddBrand', response)
        }
      })
    },

  }
}

</script>